import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { customHeaders, programManagementURL } from '../../../../../Containers/Config/index.js';
import apiCall from '../../../apiCall.js';
import { GET_BOOKING_ANALYTICS, GET_BOOKING_ANALYTICS_ERROR, GET_BOOKING_ANALYTICS_SUCCESS } from '../../actions.js';

function* getBookingsAnalytics({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${programManagementURL}/v1/booking-analytics`,
      method: 'GET',
      headers: {
        ...filteredHeaders,
      },
      params: payload?.urlParams,
    });

    if (response.status === 200) {
      yield put({
        type: GET_BOOKING_ANALYTICS_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_BOOKING_ANALYTICS_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_BOOKING_ANALYTICS_ERROR, payload: error });
  }
}

export function* watchGetBookingsAnalytics() {
  yield takeEvery(GET_BOOKING_ANALYTICS, getBookingsAnalytics);
}

function* getBookingsAnalyticsSaga() {
  yield all([fork(watchGetBookingsAnalytics)]);
}

export default getBookingsAnalyticsSaga;
